interface Props {
  isView: boolean
  deliveryNotes: string
  setDeliveryNotes: (value: string) => void
}

const DeliveryAgreementSection: React.FC<Props> = ({ isView, deliveryNotes, setDeliveryNotes }) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>รายละเอียดการส่ง (ที่ตกลงกับลูกค้า)</div>
        </div>
        <div className='card-body'>
          <textarea
            className='form-control form-control-sm'
            rows={4}
            value={deliveryNotes}
            disabled={isView}
            onChange={e => setDeliveryNotes(e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}

export default DeliveryAgreementSection
